import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import connect from '../../core/EcrionProvider/connect';
import autoRefresh from '../autoRefresh';
import cacheStrategy from '../cacheStrategy';
import DataItemAPI from '../actions/item';
import itemSelector from '../selectors/item';
var DataItemContainer = connect(function (state, ownProps) {
  return {
    value: itemSelector(state, ownProps)
  };
})(function (_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return children(_objectSpread({}, rest));
});
/**
 * @extends {React.Component<import('data/types').DataItemProps>}
 */

var DataItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataItem, _React$Component);

  function DataItem(props) {
    var _this;

    _classCallCheck(this, DataItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataItem).call(this, props));

    _this.loadData = function (options) {
      var state = {
        loading: true,
        error: null
      };
      if (!_this.mounted) _this.state = state;else _this.setState(state);
      return DataItemAPI(_objectSpread({}, _this.props, options)).fetch().then(function (action) {
        if (action.failed) {
          var error = action.payload;

          if (!_this.unmounted) {
            _this.setState({
              loading: false,
              error: error
            });
          }
        } else {
          if (!_this.unmounted) {
            _this.setState(function (s) {
              return {
                loading: false,
                error: null
              };
            });
          }
        }

        return action;
      });
    };

    var id = _this.props.id;
    var needsFetch = false;
    if (typeof id !== 'undefined' && id !== null) needsFetch = cacheStrategy(_this.props, _this.loadData);
    _this.autoRefresh = autoRefresh(_this.props, _this.loadData);
    _this.state = {
      loading: !!needsFetch,
      error: null
    };
    return _this;
  }

  _createClass(DataItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.autoRefresh.stop();
      this.unmounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["children"]);

      var _this$state = this.state,
          error = _this$state.error,
          loading = _this$state.loading;
      return React.createElement(DataItemContainer, rest, function (_ref2) {
        var value = _ref2.value;
        return _this2.props.children({
          value: value,
          error: error,
          loading: loading,
          actions: DataItemAPI(_this2.props)
        });
      });
    }
  }]);

  return DataItem;
}(React.Component);

DataItem.defaultProps = {
  cacheStrategy: 'cache-first'
};
export default DataItem;